var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_core.js
// module id = 1330
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16